(function ($) {
    function expandStudyAreas($section) {
        $section.addClass('is-expanded');
        $section.find('[data-study-areas-more]')
            .attr('aria-expanded', 'true')
            .text('Show less study areas');
    }

    function collapseStudyAreas($section) {
        $section.removeClass('is-expanded');
        $section.find('[data-study-areas-more]')
            .attr('aria-expanded', 'false')
            .text('View more study areas');
    }

    $(document).on('click', '[data-study-areas-more]', function () {
        const $section = $(this).closest('[data-study-areas]');
        if ($section.hasClass('is-expanded')) {
            collapseStudyAreas($section);
        } else {
            expandStudyAreas($section);
        }
    });
})(jQuery);
